import { render, staticRenderFns } from "./qa.vue?vue&type=template&id=729ebcbc&scoped=true"
import script from "./qa.vue?vue&type=script&lang=ts"
export * from "./qa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729ebcbc",
  null
  
)

export default component.exports